import { render, staticRenderFns } from "./BasicPlan_mobile.vue?vue&type=template&id=96b808f6&scoped=true"
import script from "./BasicPlan_mobile.vue?vue&type=script&lang=js"
export * from "./BasicPlan_mobile.vue?vue&type=script&lang=js"
import style0 from "./BasicPlan_mobile.vue?vue&type=style&index=0&id=96b808f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b808f6",
  null
  
)

export default component.exports